module.exports = __webpack_public_path__ + "img/enterprise-api-hub.c913ae68.jpg";